import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../redux/axios";

const initialState = {
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
  data: null,
};

export const regenerateApiKey = createAsyncThunk(
  "apiKey/regenerate",
  async (encryptData, thunkAPI) => {
    try {
      const endpoint = "/login/updateApiKey";
      const body = `encryptData=${encryptData}`;
      const response = await axios.put(endpoint, body, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
      });
      if (response.status?.toString().startsWith("2")) {
        return { data: response.data, status: response.status };
      }
      return thunkAPI.rejectWithValue(response.data?.message || "Failed");
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to regenerate API key."
      );
    }
  }
);

const updateApiKeySlice = createSlice({
  name: "updateApiKey",
  initialState,
  reducers: {
    clearStateApiKey: (state) => {
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
      state.successMessage = "";
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(regenerateApiKey.pending, (state) => {
        state.isFetching = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(regenerateApiKey.fulfilled, (state, action) => {
        state.isFetching = false;
        state.isSuccess = true;
        state.isError = false;
        const msg =
          typeof action.payload?.data === "string"
            ? action.payload.data
            : action.payload?.data?.message || "API key reset successfully";
        state.successMessage = msg;
        state.data = action.payload?.data;
      })
      .addCase(regenerateApiKey.rejected, (state, action) => {
        state.isFetching = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage =
          action.payload || "Failed to regenerate API key.";
      });
  },
});

export const { clearStateApiKey } = updateApiKeySlice.actions;
export const updateApiKeySelector = (state) => state.updateApiKey;
export default updateApiKeySlice.reducer;
